<template>
<div class='vx-col w-full'>
    <h4>Lista de estudiantes</h4>
    {{ enviar_datos }}
</div>
</template>

<script>
export default {
    props: {
        enviar_datos: {
            type: Object,
            default: () => {}
        }
    },
    components: {},
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {}
};
</script>
